import { useState, useCallback } from "react"
import { Transition } from "@headlessui/react"
import DatagridResumenUsuario from "./DatagridResumenUsuario"
import DatagridResumenCargo from "./DatagridResumenCargo"

const Resumenes = ({resumen, showResumen, title, month, year}) => {

    const [domNode, setDomNode] = useState(null)
    const resumenRef = useCallback((node) => {
      setDomNode(node)
    }, [])

    if(domNode && showResumen){
      domNode.scrollIntoView(
          {
              block: 'start',
              behavior: 'smooth'
          }
      )
    }

    return(
        <Transition ref={resumenRef} show={showResumen && resumen.data ? true : false}>
            {
                resumen.Opcion ?
                (resumen.Opcion === 'Usuario' 
                ?
                <DatagridResumenUsuario
                    data={resumen.data}
                    title={title}
                    month={month}
                    year={year}
                />
                :
                <DatagridResumenCargo
                    data={resumen.data}
                    title={title}
                    month={month}
                    year={year}
                />)
                : null
            }
        </Transition>
    )
}

export default Resumenes